import script from "./AreasStreetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AreasStreetsView.vue?vue&type=script&setup=true&lang=js"

import "./AreasStreetsView.vue?vue&type=style&index=0&id=003b8db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003b8db8"]])

export default __exports__